import { render } from "./ConfirmationPaiement.vue?vue&type=template&id=bf33eb7a&scoped=true&ts=true"
import script from "./ConfirmationPaiement.vue?vue&type=script&lang=ts"
export * from "./ConfirmationPaiement.vue?vue&type=script&lang=ts"

import "./ConfirmationPaiement.vue?vue&type=style&index=0&id=bf33eb7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf33eb7a"]])

export default __exports__